require('./liveInLabConsent');
require('./showConsent');
require('./setFacilityId');
require('./setFacilityIdTemplate');
